import axios from "axios";

const aapi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin` });

aapi.interceptors.request.use((config) => {
  const t = localStorage.getItem("bk_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const getAdminToken = () => localStorage.getItem("bk_admin_token");
export const setAdminToken = (t) => localStorage.setItem("bk_admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("bk_admin_token");

export { formatApiError, inr, fmtDate } from "@/panel/api";

export default aapi;
